import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import Documents from "@components/modules/projects/documents";
import { NavigationProjects } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Project documents`}
    navigation={<NavigationProjects projectId={id} />}
  >
    <Documents id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/projects/documents")({
  component: RouteComponent,
});
